<template>
  <validation-provider
    :rules="rules"
    v-slot="{ errors }"
  >
    <div class="form-group" :class="{ '-has-error': errors.length > 0 }">
      <legend class="label">
        {{ label }}

        <span v-if="tip" :data-tooltip="tip">
          <ion-icon class="icon" name="help-circle-outline"></ion-icon>
        </span>
      </legend>

      <div
        class="form-check"
        v-for="option in options"
        :key="`${name}-${option.value}`"
      >
        <input
          type="radio"
          class="form-check-input"
          :id="`${name}-${option.value}`"
          :name="name"
          :value="option.value"
          :checked="value === option.value"
          :disabled="disabled"
          @change="$emit('input', option.value)"
        >
        <label
          :for="`${name}-${option.value}`"
          class="form-check-label"
        >{{ option.label }}</label>
      </div>

      <p class="description" v-if="errors.length > 0">{{ errors[0] }}</p>
    </div>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'RadioField',

  props: {
    name: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    value: {
      required: true,
    },
    options: {
      required: true,
      type: Array,
    },
    tip: {
      required: false,
      type: String,
      default: '',
    },
    disabled: {
      required: false,
      type: Boolean,
    },
    required: {
      required: false,
      type: Boolean,
    },
  },

  computed: {
    rules() {
      if (this.disabled) {
        return '';
      }

      const rules = [];

      if (this.required) {
        rules.push('required');
      }

      return rules.join('|');
    },
  },

  components: {
    ValidationProvider,
  },
};
</script>

<style scoped>

</style>
